import { useSearchParams } from "react-router-dom";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProductOfferingConfigsPageView } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { ProductOfferingParams } from "src/routes/routesDef";

export function ProductOfferingConfigsPage() {
  const { developmentId, productOfferingId } = useRouteParams<ProductOfferingParams>();
  const [searchParams] = useSearchParams();
  const rpavId = searchParams.get("rpavId") ?? undefined;
  return <ProductOfferingConfigsPageView marketsOrIds={{ developmentId, productOfferingId, rpavId }} />;
}
